import React, { useMemo } from "react";
import TimeSelect from "./TimeSelect";
import {
  ACCOUNT_TIMEZONE_OPTIONS,
  USER_WORKING_HOURS_TZ_OPTIONS,
} from "../shared/utils/timezoneOptions";

const defaultButtonStyle = {
  padding: "6px 8px",
  fontSize: "13px",
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
};

/**
 * Reusable IANA time zone picker: same UX as time dropdowns (max visible rows + scroll, optional portal).
 *
 * @param {'account'|'user'} [variant='account'] - `account`: server default + zones; `user`: org/device + zones.
 * @param {Array<{value:string,label:string}>} [options] - override option list (e.g. tests)
 * @param {string} [value]
 * @param {(value: string) => void} onChange
 * @param {string} [id]
 * @param {boolean} [disabled]
 * @param {number} [maxVisibleItems=5]
 * @param {boolean} [dropdownPortal=true] - use false if parent has no overflow clipping
 * @param {string} [title='Time zone']
 * @param {Object} [style] - merged onto the trigger button style
 * @param {string} [className] - wrapper div
 */
function TimezoneSelect({
  variant = "account",
  options: optionsProp,
  value,
  onChange,
  id,
  disabled = false,
  maxVisibleItems = 5,
  dropdownPortal = true,
  title = "Time zone",
  style,
  className,
}) {
  const options = useMemo(
    () =>
      optionsProp != null
        ? optionsProp
        : variant === "user"
          ? USER_WORKING_HOURS_TZ_OPTIONS
          : ACCOUNT_TIMEZONE_OPTIONS,
    [optionsProp, variant]
  );

  return (
    <div style={{ width: "100%", minWidth: 0 }} className={className}>
      <TimeSelect
        id={id}
        value={value ?? ""}
        onChange={(v) => {
          if (onChange) onChange(v == null ? "" : String(v));
        }}
        options={options}
        maxVisibleItems={maxVisibleItems}
        title={title}
        style={{ ...defaultButtonStyle, ...(style || {}) }}
        disabled={disabled}
        dropdownPortal={dropdownPortal}
      />
    </div>
  );
}

export default TimezoneSelect;
